import type { NodeProps } from '@xyflow/react';
import { memo, useContext } from 'react';

import { EntityDetailsPopover } from '../../common/EntityDetailsPopover';
import type { StructureEntityFlowNode } from '../canvas';
import { EntityCard } from './EntityCard';
import { FocusedEntityContext } from './FocusedEntityContext';

const StructureEntityNode = memo(function StructureEntityNode({
  data,
}: NodeProps<StructureEntityFlowNode>) {
  const focusedEntityId = useContext(FocusedEntityContext);
  return (
    <EntityDetailsPopover
      entity={data.entity.source}
      typeLabel={data.typeLabel}
      fallbackName={data.entity.name}
      nameLang={data.nameLang}
      isNameTruncated={data.isNameTruncated}
    >
      <EntityCard
        entity={data.entity}
        typeLabel={data.typeLabel}
        nameLang={data.nameLang}
        isFocused={focusedEntityId === data.entity.id}
      />
    </EntityDetailsPopover>
  );
});

export { StructureEntityNode };
